const UPLOAD_TYPE = {
  IMAGE: 'image',
  AUDIO: 'audio',
  VIDEO: 'video',
};

const REQUIRED_MESSAGE = 'Trường này là bắt buộc.';

const FILE_FORMAT = {
  [UPLOAD_TYPE.IMAGE]: ['png', 'jpeg', 'jpg', 'svg'],
  [UPLOAD_TYPE.AUDIO]: [
    'mp3',
    'wav',
    'ogg',
    'mp4',
    'adts',
    '3gp',
    'mov',
    'flac',
    'm4a',
    'webm',
    'mpeg',
  ],
  [UPLOAD_TYPE.VIDEO]: ['mp4', 'webm', '3gp', 'ogg', 'mpeg'],
};

export enum ROLE_USER {
  USER = 'USER',
  ADMIN = 'ADMIN',
  MOD = 'MOD',
  AGENCY = 'AGENCY',
  CREATOR = 'CREATOR',
  STUDIO_CREATOR = 'STUDIO_CREATOR',
}

export const SORT_DIRECTION = {
  UP: 'ASC',
  DOWN: 'DESC',
};

export enum TYPE_NEW {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum TYPE_SOUND {
  MUSIC = 'MUSIC',
  SOUND_EFFECT = 'SOUND_EFFECT',
  PAY_THE_BET = 'PAY_THE_BET',
  SYNTHETIC = 'SYNTHETIC',
}

export enum TYPE_MENU {
  ALL = 'ALL',
  AGENCY = 'AGENCY',
  CREATOR = 'CREATOR',
  HP_COMPANY = 'HP_COMPANY',
  ADMIN = 'ADMIN',
}
export enum TYPE_LIVE_SHOW {
  ALL = 'ALL',
  CAROUSEL = 'CAROUSEL',
}

export enum ATTENDANCE_STATUS {
  NORMAL = 'normal',
  LATE = 'late',
  EARLY = 'early',
  LATE_EARLY = 'late-early',
  ABSENT = 'absent',
  NO_CHECKOUT = 'no-checkout',
  FORGOT_CHECKIN = 'forgot-checkin',
}

export enum TYPE_BANNER {
  HOME = 'HOME',
  LIVE_SHOW = 'LIVE_SHOW',
  PK = 'PK',
}

export enum TYPE_JOB {
  NOW = 'NOW',
  NO = 'NO',
  CALENDAR = 'CALENDAR',
}

export enum TYPE_DEPARTMENT {
  HR = 'HR',
  TECHNICAL = 'TECHNICAL',
  MAKEUP = 'MAKEUP',
  MC = 'MC',
  IDOL = 'IDOL',
  CONTENT = 'CONTENT',
  STYLE_LIST = 'STYLE_LIST',
  DANCE_TEACHER = 'DANCE_TEACHER',
  MANAGER = 'MANAGER',
}

export const MONTHS = [
  { value: 1, month: '1' },
  { value: 2, month: '1' },
  { value: 3, month: '1' },
  { value: 4, month: '1' },
  { value: 1, month: '1' },
  { value: 1, month: '1' },
  { value: 1, month: '1' },
  { value: 1, month: '1' },
  { value: 1, month: '1' },
  { value: 1, month: '1' },
];

export const LIST_DEFAULT_SHIFT = [
  {
    id: 1,
    name: 'HR 09:00-18:00',
    department: 'HR',
    startTime: '09:00',
    endTime: '18:00',
    isActive: true,
    createdAt: '2025-11-13T14:15:47.477Z',
    updatedAt: '2025-11-13T14:15:47.477Z',
    deletedAt: null,
  },
  {
    id: 2,
    name: 'HR 13:00-22:00',
    department: 'HR',
    startTime: '13:00',
    endTime: '22:00',
    isActive: true,
    createdAt: '2025-11-13T14:15:47.487Z',
    updatedAt: '2025-11-13T14:15:47.487Z',
    deletedAt: null,
  },
  {
    id: 3,
    name: 'KT 10:00-18:00',
    department: 'TECHNICAL',
    startTime: '10:00',
    endTime: '18:00',
    isActive: true,
    createdAt: '2025-11-13T14:15:47.498Z',
    updatedAt: '2025-11-13T14:15:47.498Z',
    deletedAt: null,
  },
  {
    id: 4,
    name: 'KT 17:00-01:00',
    department: 'TECHNICAL',
    startTime: '17:00',
    endTime: '01:00',
    isActive: true,
    createdAt: '2025-11-13T14:15:47.507Z',
    updatedAt: '2025-11-13T14:15:47.507Z',
    deletedAt: null,
  },
  {
    id: 10,
    name: 'Idol 11:00-16:30',
    department: 'IDOL',
    startTime: '11:00',
    endTime: '16:30',
    isActive: true,
    createdAt: '2025-12-25T14:56:17.450Z',
    updatedAt: '2025-12-25T14:56:17.450Z',
    deletedAt: null,
  },
  {
    id: 11,
    name: 'Idol 19:00-00:30',
    department: 'IDOL',
    startTime: '19:00',
    endTime: '00:30',
    isActive: true,
    createdAt: '2025-12-25T14:56:17.450Z',
    updatedAt: '2025-12-25T14:56:17.450Z',
    deletedAt: null,
  },
];

export const REGEX_USERNAME = /^[a-zA-Z0-9_.]+$/;

export { UPLOAD_TYPE, REQUIRED_MESSAGE, FILE_FORMAT };
